import React from 'react';
import { useTranslation } from 'react-i18next';

// Copyright line shared by public and customer-facing pages
export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="text-gray-500 text-sm py-4 w-full text-center">
      {t('home.rights', { year: new Date().getFullYear() })}
    </footer>
  );
}
